import React from 'react'
import PlayIcon from 'assets/play_icon.svg'
import { FiHeart } from 'react-icons/fi'
import { useAudioMetadata } from './useAudioMetadata'
import { useEpisodeProgress } from './useEpisodeProgress'

const CardAudioPlayer = ({
  episode,
  onPlay = () => {},
}: {
  episode: any
  onPlay?: () => void
}) => {
  const { duration, formattedDuration } = useAudioMetadata(episode.audio_file)
  const secondsUserHasListened = useEpisodeProgress(episode.uuid)

  const progressPercentage =
    duration && secondsUserHasListened
      ? Math.min((secondsUserHasListened / duration) * 100, 100)
      : 0

  return (
    <div className='controls mt-2 w-full'>
      <div className='flex flex-nowrap lg:flex-wrap items-center w-full overflow-hidden whitespace-nowrap'>
        <div className='flex flex-nowrap lg:flex-wrap items-center w-[80%] gap-x-[10px] gap-y-[6px] min-w-0'>
          <div className='action flex items-center gap-[6px] flex-shrink-0'>
            <FiHeart size={20} />
            {episode.views_count} plays
          </div>
          <div className='flex flex-nowrap lg:flex-wrap items-center gap-[10px] flex-grow min-w-0'>
            <span className='flex-shrink-0'>{formattedDuration}</span>
            <div className='h-1 bg-gray-200 rounded overflow-hidden flex-grow min-w-0'>
              <div
                className='timer h-1 bg-[#5858DF] rounded'
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>

        <button className='play flex-shrink-0 ml-2' onClick={onPlay}>
          <img className='icon w-[20px] h-[20px]' src={PlayIcon} alt='Play' />
        </button>
      </div>
    </div>
  )
}

export default CardAudioPlayer
